/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaSubcategory,
    MediaSubcategoryFromJSON,
    MediaSubcategoryFromJSONTyped,
    MediaSubcategoryToJSON,
} from './MediaSubcategory';

/**
 * カテゴリ
 * @export
 * @interface MediaCategory
 */
export interface MediaCategory {
    /**
     * カテゴリID
     * @type {number}
     * @memberof MediaCategory
     */
    categoryId: number;
    /**
     * カテゴリ名
     * @type {string}
     * @memberof MediaCategory
     */
    categoryName: string;
    /**
     * サブカテゴリ一覧
     * @type {Array<MediaSubcategory>}
     * @memberof MediaCategory
     */
    subcategories: Array<MediaSubcategory>;
}

export function MediaCategoryFromJSON(json: any): MediaCategory {
    return MediaCategoryFromJSONTyped(json, false);
}

export function MediaCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryId': json['category_id'],
        'categoryName': json['category_name'],
        'subcategories': ((json['subcategories'] as Array<any>).map(MediaSubcategoryFromJSON)),
    };
}

export function MediaCategoryToJSON(value?: MediaCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category_id': value.categoryId,
        'category_name': value.categoryName,
        'subcategories': ((value.subcategories as Array<any>).map(MediaSubcategoryToJSON)),
    };
}

